/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShadowComponentCriterionDetail } from './ShadowComponentCriterionDetail';
import {
    ShadowComponentCriterionDetailFromJSON,
    ShadowComponentCriterionDetailFromJSONTyped,
    ShadowComponentCriterionDetailToJSON,
} from './ShadowComponentCriterionDetail';
import type { ShadowDealbreakerFlag } from './ShadowDealbreakerFlag';
import {
    ShadowDealbreakerFlagFromJSON,
    ShadowDealbreakerFlagFromJSONTyped,
    ShadowDealbreakerFlagToJSON,
} from './ShadowDealbreakerFlag';

/**
 * Optional scoring breakdown attached to clinical / financial subsystem results.
 * @export
 * @interface ShadowSubsystemScoring
 */
export interface ShadowSubsystemScoring {
    /**
     * 
     * @type {number}
     * @memberof ShadowSubsystemScoring
     */
    insurance_score?: number;
    /**
     * 
     * @type {number}
     * @memberof ShadowSubsystemScoring
     */
    medication_rules_score?: number;
    /**
     * 
     * @type {number}
     * @memberof ShadowSubsystemScoring
     */
    dealbreaker_rules_score?: number;
    /**
     * 
     * @type {number}
     * @memberof ShadowSubsystemScoring
     */
    warning_rules_score?: number;
    /**
     * 
     * @type {Array<ShadowDealbreakerFlag>}
     * @memberof ShadowSubsystemScoring
     */
    dealbreaker_flags?: Array<ShadowDealbreakerFlag>;
    /**
     * 
     * @type {Array<ShadowComponentCriterionDetail>}
     * @memberof ShadowSubsystemScoring
     */
    component_detail?: Array<ShadowComponentCriterionDetail>;
}

/**
 * Check if a given object implements the ShadowSubsystemScoring interface.
 */
export function instanceOfShadowSubsystemScoring(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShadowSubsystemScoringFromJSON(json: any): ShadowSubsystemScoring {
    return ShadowSubsystemScoringFromJSONTyped(json, false);
}

export function ShadowSubsystemScoringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShadowSubsystemScoring {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'insurance_score': !exists(json, 'insurance_score') ? undefined : json['insurance_score'],
        'medication_rules_score': !exists(json, 'medication_rules_score') ? undefined : json['medication_rules_score'],
        'dealbreaker_rules_score': !exists(json, 'dealbreaker_rules_score') ? undefined : json['dealbreaker_rules_score'],
        'warning_rules_score': !exists(json, 'warning_rules_score') ? undefined : json['warning_rules_score'],
        'dealbreaker_flags': !exists(json, 'dealbreaker_flags') ? undefined : ((json['dealbreaker_flags'] as Array<any>).map(ShadowDealbreakerFlagFromJSON)),
        'component_detail': !exists(json, 'component_detail') ? undefined : ((json['component_detail'] as Array<any>).map(ShadowComponentCriterionDetailFromJSON)),
    };
}

export function ShadowSubsystemScoringToJSON(value?: ShadowSubsystemScoring | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'insurance_score': value.insurance_score,
        'medication_rules_score': value.medication_rules_score,
        'dealbreaker_rules_score': value.dealbreaker_rules_score,
        'warning_rules_score': value.warning_rules_score,
        'dealbreaker_flags': value.dealbreaker_flags === undefined ? undefined : ((value.dealbreaker_flags as Array<any>).map(ShadowDealbreakerFlagToJSON)),
        'component_detail': value.component_detail === undefined ? undefined : ((value.component_detail as Array<any>).map(ShadowComponentCriterionDetailToJSON)),
    };
}

